import type { ComponentRef } from '@wix/editor-platform-sdk-types'
import type {
  EditorSDK,
  BuilderConnection,
} from '@wix/wix-data-client-common-standalone'

type FieldKey = string

type ControllerConnection = {
  componentRef: ComponentRef
  connection: BuilderConnection
}

export const fetchUsedSchemaFieldsByController = async ({
  editorSdkProxy,
  controllerRef,
}: {
  editorSdkProxy: EditorSDK
  controllerRef: ComponentRef
}): Promise<FieldKey[]> => {
  const connections =
    await editorSdkProxy.controllers.listControllerConnections({
      controllerRef,
    })

  if (
    connections.some(({ connection }) => connection.config?.type !== 'binding')
  ) {
    throw new Error('Not supported connection type')
  }
  return getUsedFieldsFromBuilderConnections(
    connections as ControllerConnection[],
  )
}

function getUsedFieldsFromBuilderConnections(
  connections: ControllerConnection[],
) {
  const connectionsConfigs = connections.map(
    ({ connection }) => connection.config,
  )

  const byItem = connectionsConfigs.map(({ byItem }) => byItem)
  const usedFields = byItem.flatMap(item =>
    Object.values(item).reduce<string[]>((acc, curr) => {
      acc.push(curr.config.fieldKey)
      return acc
    }, []),
  )
  return Array.from(new Set(usedFields))
}
